import { createSlice } from '@reduxjs/toolkit';
import { boolean } from 'yup';
import lib from '../../biz/lib';

// export interface AgentState {
//   _id: string | null
//   userName: string
//   name: string
//   email: string
//   image: string
//   views: string
//   expiryDate: Date | null
//   state: string
//   area: string
//   loc: any | null
// }



const initialState = {
  _id: null,
  role: '',
  unread: [],
  excludedCond: true,
  isAllSubscrExpired: true,
  profile:{
    _id: null,
    modules: [],
    updated: null
  },
  created: new Date()
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserSlice: (state, action) => {
      return {
        ...action.payload,
        
      }
    }
    //to add logout reducer here
  },
})

export const { updateUserSlice, logOut } = userSlice.actions

export const getIsAllSubscrExpired = state => {
  const userState = state.user;

  // const excludedCond = lib.getExcludedCond(userState);

  const isSubscriptionExpired = userState?.role === 'Owner' && userState?.isAllSubscrExpired === true;
  // const isSubscriptionExpired = userState?.role === 'Owner' && userState?.isAllSubscrExpired === true && !excludedCond;
  return isSubscriptionExpired;
}


export default userSlice.reducer